import React, { FunctionComponent } from "react";
import styles from "../styles/SystemsDashboard.css";
import Body from "./Body";

interface Props {}

const SystemsDashboard: FunctionComponent<Props> = () => {

    return (
        <div className={styles.bodyContainer} >
            <Body />
        </div>
    )
}

export default SystemsDashboard;